export default "__VITE_ASSET__D3uXAd2U__"